export const colors = [
  'bg-sky-600',
  'bg-orange-600',
  'bg-fuchsia-500',
  'bg-green-400',
  'bg-violet-500',
  'bg-rose-400',
  'bg-cyan-600',
  'bg-lime-500',
  'bg-red-500',
  'bg-teal-400',
  'bg-indigo-600',
  'bg-purple-400',
  'bg-sky-400',
  'bg-amber-600',
  'bg-pink-500',
  'bg-yellow-400',
  'bg-emerald-600',
  'bg-red-400',
  'bg-amber-500',
  'bg-green-600',
  'bg-blue-400',
  'bg-violet-600',
  'bg-rose-500',
  'bg-cyan-400',
  'bg-lime-600',
  'bg-orange-400',
  'bg-teal-600',
  'bg-fuchsia-600',
  'bg-indigo-400',
  'bg-purple-500',
  'bg-blue-600',
  'bg-pink-600',
  'bg-yellow-500',
  'bg-emerald-400',
  'bg-red-600',
];

export const colorGradients = [
  'from-red-500 to-red-500 text-red-600 border-red-500',
  'from-purple-500/20 to-purple-500/10 text-purple-600 border-purple-500/20',
  'from-teal-500/20 to-teal-500/10 text-teal-600 border-teal-500/20',
  'from-sky-600/20 to-sky-600/10 text-sky-600 border-sky-600/20',
  'from-orange-600/20 to-orange-600/10 text-orange-600 border-orange-600/20',
  'from-fuchsia-500/20 to-fuchsia-500/10 text-fuchsia-500 border-fuchsia-500/20',
  'from-green-400/20 to-green-400/10 text-green-400 border-green-400/20',
  'from-violet-500/20 to-violet-500/10 text-violet-500 border-violet-500/20',
];

const colorMap: Record<string, string> = {
  'bg-red-400': '#fc8181',
  'bg-red-500': '#f56565',
  'bg-red-600': '#e53e3e',
  'bg-orange-400': '#fd9a66',
  'bg-orange-500': '#ed8936',
  'bg-orange-600': '#dd6b20',
  'bg-amber-400': '#fbd38d',
  'bg-amber-500': '#f6ad55',
  'bg-amber-600': '#dd6b20',
  'bg-yellow-400': '#f6e05e',
  'bg-yellow-500': '#ecc94b',
  'bg-yellow-600': '#d69e2e',
  'bg-lime-400': '#bef264',
  'bg-lime-500': '#a3e635',
  'bg-lime-600': '#8cd36f',
  'bg-green-400': '#68d391',
  'bg-green-500': '#48bb78',
  'bg-green-600': '#38a169',
  'bg-emerald-400': '#4fd1c5',
  'bg-emerald-500': '#38b2ac',
  'bg-emerald-600': '#319795',
  'bg-teal-400': '#4fd1c5',
  'bg-teal-500': '#38b2ac',
  'bg-teal-600': '#319795',
  'bg-cyan-400': '#63b3ed',
  'bg-cyan-500': '#4299e1',
  'bg-cyan-600': '#3182ce',
  'bg-sky-400': '#7dd3fc',
  'bg-sky-500': '#5ba3fa',
  'bg-sky-600': '#4299e1',
  'bg-blue-400': '#63b3ed',
  'bg-blue-500': '#4299e1',
  'bg-blue-600': '#3182ce',
  'bg-indigo-400': '#7f9cf5',
  'bg-indigo-500': '#667eea',
  'bg-indigo-600': '#5a67d8',
  'bg-violet-400': '#b794f4',
  'bg-violet-500': '#9f7aea',
  'bg-violet-600': '#805ad5',
  'bg-purple-400': '#b794f4',
  'bg-purple-500': '#9f7aea',
  'bg-purple-600': '#805ad5',
  'bg-fuchsia-400': '#f687b3',
  'bg-fuchsia-500': '#ed64a6',
  'bg-fuchsia-600': '#d53f8c',
  'bg-pink-400': '#f687b3',
  'bg-pink-500': '#ed64a6',
  'bg-pink-600': '#d53f8c',
  'bg-rose-400': '#fb7185',
  'bg-rose-500': '#f43f5e',
  'bg-rose-600': '#e11d48',
};

export function getDeterministicColorHex(index: number) {
  const selectedColor = getDeterministicColor(index);
  return colorMap[selectedColor];
}

export function getDeterministicColor(index: number) {
  return colors[index % colors.length];
}

export function getDeterministicColorGradients(index: number) {
  return colorGradients[index % colors.length];
}

export function getDeterministicColorSet(index: number): {
  color: string;
  hexColor: string;
} {
  const color = getDeterministicColor(index);
  const hexColor = colorMap[color];
  return { color, hexColor };
}
